import { baseApi } from "../baseApi";
const COD_TRANSFER_BASE_URL = "/codTransfers";

export const CodTransferApi = baseApi.injectEndpoints({
  tagTypes: ["CodTransfer"],
  endpoints: (builder) => ({
    createCodTransfer: builder.mutation({
      query: (payload) => ({
        url: `${COD_TRANSFER_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [{ type: "CodTransfer", id: "LIST" }],
    }),
    getCodTransferList: builder.query({
      query: (params) => ({
        url: `${COD_TRANSFER_BASE_URL}`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "CodTransfer",
                id: _id,
              })),
              { type: "CodTransfer", id: "LIST" },
            ]
          : [{ type: "CodTransfer", id: "LIST" }],
    }),

    getCodTransfersByVendorId: builder.query({
      query: ({ vendorId, params }) => ({
        url: `${COD_TRANSFER_BASE_URL}/vendor/${vendorId}`,
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result && Array.isArray(result.data)
          ? [
              ...result.data.map(({ _id }) => ({
                type: "CodTransfer",
                id: _id,
              })),
              { type: "CodTransfer", id: "LIST" },
            ]
          : [{ type: "CodTransfer", id: "LIST" }],
    }),

    getCodTransferDetail: builder.query({
      query: (id) => `${COD_TRANSFER_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "CodTransfer", id },
        { type: "CodTransfer", id: "LIST" },
      ],
    }),
    printCodTransferEBill: builder.mutation({
      query: (id) => ({
        url: `${COD_TRANSFER_BASE_URL}/${id}/ebill/print`,
        method: "POST",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "CodTransfer", id },
      ],
    }),

    updateCodTransfer: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;
        return {
          url: `${COD_TRANSFER_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "CodTransfer", id: _id },
        { type: "CodTransfer", id: "LIST" },
      ],
    }),
     getCODTransferDDL: builder.query({
      query: (params) => {
        return { url: `${COD_TRANSFER_BASE_URL}/ddl`, params };
      },
    }),
    listShipmentsByCodTransferId: builder.query({
      query: ({ codId, page, limit }) => ({
        url: `${COD_TRANSFER_BASE_URL}/${codId}/shipments`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Consolidation", id: _id },
        { type: "Consolidation", id: "LIST" },
    ],
    }),
    listShipmentsByCodTransferIdPrint: builder.query({
      query: ({ codId, page, limit }) => ({
        url: `${COD_TRANSFER_BASE_URL}/${codId}/shipmentPrints`,
        params: { page, limit },
      }),
      providesTags: (_result, _error, { _id }) => [
        { type: "Consolidation", id: _id },
        { type: "Consolidation", id: "LIST" },
    ],
    }),
    listCodTransferAmountsByVendor: builder.query({
      query: ({ vendorId, page, limit, keyword }) => ({
        url: `${COD_TRANSFER_BASE_URL}/vendor/${vendorId}/transfer-amounts`,
        params: { page, limit, keyword },
      }),
      providesTags: (_result, _error, { vendorId }) => [
        { type: "CodTransfer", id: vendorId },
        { type: "CodTransfer", id: "LIST" },
      ],
    }),
    getCodTransferChargeDetail: builder.query({
      query: (id) => `${COD_TRANSFER_BASE_URL}/${id}/charge-detail`,
      providesTags: (result, error, id) => [
        { type: "CodTransfer", id },
        { type: "CodTransfer", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetCodTransferListQuery,
  useLazyGetCodTransferListQuery,

  useGetCodTransfersByVendorIdQuery,
  useLazyGetCodTransfersByVendorIdQuery,

  useGetCodTransferDetailQuery,
  usePrintCodTransferEBillMutation,
  useCreateCodTransferMutation,
  useUpdateCodTransferMutation,
  useLazyGetCODTransferDDLQuery,

  useLazyListShipmentsByCodTransferIdQuery, 
  useLazyListShipmentsByCodTransferIdPrintQuery,
  useLazyListCodTransferAmountsByVendorQuery,

  useGetCodTransferChargeDetailQuery,
  useLazyGetCodTransferChargeDetailQuery,
} = CodTransferApi;
